/**
 * @voltxampere/components — Ground reference
 *
 * Single-pin reference component. The ground net itself lives at the
 * `Net` level (per SPECS §1.2 invariants — exactly one `Net.isGround`),
 * but the schematic still places explicit ground symbols so users can
 * see the reference visually.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { z } from "zod";
export const GroundParamsSchema = z.object({}).strict();
export const groundDefinition = {
    type: "ground",
    category: "reference",
    displayName: { tr: "Toprak", en: "Ground" },
    symbol: "GND",
    pins: [{ id: "p", side: "top", offset: 0 }],
    parameterSchema: GroundParamsSchema,
    nonlinear: false,
};
//# sourceMappingURL=ground.js.map